export default __webpack_public_path__ + "static/media/water-resistant.b5adeab0.svg";